import React from "react"

import styles from "./ImportSpendingsPage.module.scss"
import { observer } from "mobx-react"
import { ImportSpendingsStoreType } from "../models/import-store"
import { FileUploaderHOC } from "modules/common/components/files/Uploader"

import { ImportTable } from "./Table"
import { texts } from "modules/common/texts"

import { Page } from "modules/common/components/page/Page"
import { PlanrButton } from "modules/common/components/planr/button/Button"
import { LocalLoader } from "modules/common/components/loader/Loader"
import { Classes, Dialog } from "@blueprintjs/core"
import { ReturnList } from "./ReturnList"

interface ImportSpendingsPageState {
  showLog: boolean
  returned: boolean
}

class Base extends React.Component<ImportSpendingsPageProps, ImportSpendingsPageState> {
  constructor(props: ImportSpendingsPageProps) {
    super(props)

    this.state = {
      showLog: false,
      returned: false,
    }
  }
  componentDidMount() {
    document.title = "Импорт"
  }
  render() {
    const { store } = this.props

    return (
      <Page className={styles.page}>
        <LocalLoader active={store.isLoading} />
        <div className={styles.flex}>
          <FileUploaderHOC
            accept="plain/text"
            onFileSelected={store.upload}
            render={({ onClick, loading }) => (
              <PlanrButton
                type="graybtn"
                icon="general-plus"
                title={texts.upload}
                onClick={onClick}
                round={true}
                disabled={!loading ? false : true}
                style={{ marginBottom: "24px", marginRight: "10px" }}
              />
            )}
          />

          <PlanrButton
            type="lightblueish"
            icon="general-undo"
            round
            title="Возврат удаленных платежей"
            onClick={() => {
              this.setState({ showLog: true })
            }}
          />

          <Dialog
            title="Удаленные платежи"
            canEscapeKeyClose={false}
            canOutsideClickClose={false}
            isOpen={this.state.showLog}
            onClose={async () => {
              this.setState({ showLog: false })
              if (this.state.returned) {
                await store.loadTable(true)
                this.setState({ returned: false })
              }
            }}
            style={{
              width: `1250px`,
              height: "860px",
            }}
            backdropClassName="standard"
            className={`figma-dialog`}
          >
            <div className={`${Classes.DIALOG_BODY} ${styles.dialog}`}>
              <ReturnList
                store={store.returnList}
                import={store}
                setReturned={() => {
                  this.setState({ returned: true })
                }}
              />
            </div>
          </Dialog>
        </div>

        <ImportTable store={store} />
      </Page>
    )
  }
}

export const ImportSpendingsPage = observer(Base)

interface ImportSpendingsPageProps {
  store: ImportSpendingsStoreType
}
